export function convertDate(dateString: string) {
  const date = new Date(dateString)
  const formattedDate = date?.toISOString().split('T')[0]
  return formattedDate
}

export function convertDateAndTime(dateString: string): string {
  const date = new Date(dateString)

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'Europe/Stockholm',
  }

  // Format to swedish and timezone
  const formatted = new Intl.DateTimeFormat('sv-SE', options).format(date)

  const output = formatted.replace(',', ' kl.')

  return output
}
